import { App, areAppTypesEquivalent } from '@ps20-frontend/frontend-models';
import { VorschadenArt, VorversicherungsItemVersicherteGefahr } from '@ps20-frontend/shop-integration-redux';

export interface Vorversicherer {
  label: string;
  value: string;
  plz: string;
  ort: string;
}

export const ALLIANZ_ANSTALTSNUMMERN: ReadonlyArray<string> = ['AF7', 'B49'];

export const getVersicherteGefahren: (
  appId: App,
) => Array<VorversicherungsItemVersicherteGefahr> = (appId: App) => {
  if (areAppTypesEquivalent(appId, App.VWG)) {
    return [
      {
        label: 'Feuer',
        value: VorschadenArt.FEUER,
        selected: false,
      },
      {
        label: 'Sturm/Hagel',
        value: VorschadenArt.STURM_HAGEL,
        selected: false,
      },
      {
        label: 'Leitungswasser',
        value: VorschadenArt.LEITUNGSWASSER,
        selected: false,
      },
      {
        label: 'Weitere Naturgefahren',
        value: VorschadenArt.ELEMENTAR,
        selected: false,
      },
    ];
  } else if (appId === App.TKV_V2) {
    return [
      {
        label: 'OP-Schutz',
        value: VorschadenArt.OPSCHUTZ,
        selected: false,
      },
      {
        label: 'Vollschutz',
        value: VorschadenArt.VOLLSCHUTZ,
        selected: false,
      },
      {
        label: 'Nicht bekannt',
        value: VorschadenArt.NICHT_BEKANNT_SCHUTZ,
        selected: false,
      },
    ];
  } else {
    return [];
  }
};
